module.exports = __webpack_public_path__ + "img/AmericanLeaders.16bdde36.jpg";